// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"7fa5fa07","393":"6e36703f","615":"e719ebde","770":"2cbd5dc0","936":"967256c6","945":"c5a186f4"}[chunkId] + ".chunk.js";
};